/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {CartComparisonDebugCheapestBasket} from './CartComparisonDebugCheapestBasket';
import {ComparedBaskets} from './ComparedBaskets';

/**
 * The CartComparisonDebug model module.
 * @module model/CartComparisonDebug
 * @version v1
 */
export class CartComparisonDebug {
  /**
   * Constructs a new <code>CartComparisonDebug</code>.
   * @alias module:model/CartComparisonDebug
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CartComparisonDebug</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CartComparisonDebug} obj Optional instance to populate.
   * @return {module:model/CartComparisonDebug} The populated <code>CartComparisonDebug</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CartComparisonDebug();
      if (data.hasOwnProperty('cheapest_basket'))
        obj.cheapest_basket = CartComparisonDebugCheapestBasket.constructFromObject(data['cheapest_basket']);
      if (data.hasOwnProperty('baskets'))
        obj.baskets = ComparedBaskets.constructFromObject(data['baskets']);
    }
    return obj;
  }
}

/**
 * @member {module:model/CartComparisonDebugCheapestBasket} cheapest_basket
 */
CartComparisonDebug.prototype.cheapest_basket = undefined;

/**
 * @member {module:model/ComparedBaskets} baskets
 */
CartComparisonDebug.prototype.baskets = undefined;

